import { render, staticRenderFns } from "./sam_support.vue?vue&type=template&id=c7002abc"
import script from "./sam_support.vue?vue&type=script&lang=js"
export * from "./sam_support.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports